import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { BonusesSection } from './components/BonusesSection';
import { BenefitsSection } from './components/BenefitsSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotification } from './components/PurchaseNotification';
import { MetaPixel } from './components/MetaPixel';
const CHECKOUT_ORIGIN = 'https://the-basketball-coach-s-bible.impultienda.ar';
export function App() {
  // Warm the connection to the checkout domain as soon as the page loads.
  // This way, when the user clicks the CTA, DNS + TLS handshake are already done.
  useEffect(() => {
    if (typeof document === 'undefined') return;
    const tags = [{
      rel: 'dns-prefetch',
      href: CHECKOUT_ORIGIN
    }, {
      rel: 'preconnect',
      href: CHECKOUT_ORIGIN,
      crossOrigin: ''
    }];
    const created: HTMLLinkElement[] = [];
    tags.forEach(({
      rel,
      href,
      crossOrigin
    }) => {
      const link = document.createElement('link');
      link.rel = rel;
      link.href = href;
      if (crossOrigin !== undefined) link.crossOrigin = crossOrigin;
      document.head.appendChild(link);
      created.push(link);
    });
    return () => {
      created.forEach(l => l.parentNode && l.parentNode.removeChild(l));
    };
  }, []);
  return <div className="min-h-screen bg-bb-cream font-sans selection:bg-bb-orange/30 text-bb-charcoal" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Hero data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <SolutionSection data-id="element-4" />
      <BonusesSection data-id="element-5" />
      <BenefitsSection data-id="element-6" />
      <PricingSection data-id="element-7" />
      <GuaranteeSection data-id="element-8" />
      <TestimonialsSection data-id="element-9" />
      <FAQSection data-id="element-10" />
      <FinalCTA data-id="element-11" />
      <Footer data-id="element-12" />
      <PurchaseNotification data-id="element-13" />
    </div>;
}